<template>
    <div @click="closeSettings()">
        <Header :data_status="data_status" @toggleSettings="toggleSettings($event)"></Header>
        <div class="inline">
            <aside class="left-menu">
                <ConfigControls v-if="data_status == ''"></ConfigControls>
            </aside>
            <div class="content-block">
                <SettingsPopup v-if="settings.open" :settings="settings" :cols="cols"></SettingsPopup>
                <div class="table-block" v-show="data_status != 'loading'">
                    <FilterPopup :key="filterRenderKey" v-if="filterPopup.id && $store.state.settings[$route.name][filterPopup.id].value && !settings.open" :col="cols[filterPopup.id]" :maxCols="Object.keys(cols).length" :filterPopup="filterPopup" @closeFilter="closeFilter()"></FilterPopup>
                    <div class="table-wrapper" @scroll="closeFilter()">
                        <table class="table">
                            <tr class="table-row _header">
                                <td :colType="key" v-for="(value, key) in renderCols" :key="key">
                                    <div class="col-header sort" :class="{_ASC: sort.active == key && sort.direction == 'ASC', _DESC: sort.active == key && sort.direction == 'DESC'}" @click="setSort(key)"><span>{{ value.name }}</span></div>
                                    <div @click="openFilter($event, key)" class="filter-trigger" :class="{_active: !$store.state.filters[$route.name][key]['all']}"></div>
                                </td>
                            </tr>
                            <tr class="table-row" v-for="(item, index) in renderData" :key="index">
                                <td :colType="key" v-for="(value, key) in renderCols" :key="key">
                                    <router-link :to="'/' + getLink(key) + '/' + item[key].id" v-if="item[key] && item[key].id">{{ item[key].value }}</router-link>
                                    <a :href="item[key]" v-else-if="key == 'file1' || key == 'file2'" target="_blank">{{ item[key] }}</a>
                                    <span v-else>{{ item[key] }}</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <BotLine :count="data_count" :paginator.sync="paginator" :show_from="data_show_from" :show_to="data_show_to"></BotLine>
                </div>
                <div class="page-load" v-show="data_status == 'loading'">
                    <div class="inline" valign="center">
                        <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import FilterPopup from '@/components/FilterPopup.vue'
    import SettingsPopup from '@/components/SettingsPopup.vue'
    import ConfigControls from '@/components/ConfigControls.vue'
    import BotLine from '@/components/BotLine.vue'

    import data from '@/mixins/data'
    import settings from '@/mixins/settings'
    import filters from '@/mixins/filters'

    export default {
        mixins: [data, settings, filters],
        components: {
            Header,
            FilterPopup,
            SettingsPopup,
            ConfigControls,
            BotLine
        },
        methods: {
            getLink (key) {
                if (key == 'id') return 'authorization'
                if (key == 'parking') return 'parking'
                if (key == 'user') return 'users'
            }
        }
    }
</script>
